<template>
    <div class="wrapper-row item" :class="{selected: selected}">
        <div class="fixed p-4 mr-2 icon" style="width: 200px; display: flex; align-items: center;">
            <div class="wrapper-col" style="align-items: center;">
                <div style="display: flex; flex-grow: 1;"><I :name="icon" class="h2"/></div>
                <div style="display: flex; font-size: 0.8em; flex-grow: 1;" class="name mt-2">välj mall</div>
            </div>
        </div>
        <div style="flex: 1 0;" class="p-3">
            <div class="title p-1" style="">{{title}}</div>
            <div class="value p-1">{{description}}</div>
        </div>
    </div>
</template>

<script>
/* tslint:disable */

    export default {
        name: "TemplateSelection",
        props: ['selected', 'title', 'description', 'icon']
    }
</script>

<style scoped lang="scss">
    .wrapper-row {
        display: flex;
        flex-direction: row;
        background-color: white;
    }
    .wrapper-col {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
    }
    .fixed {
        flex-grow: 0;
        flex-shrink: 0;
    }
    .title {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .name {
        font-size: 0.875rem;
        color: gray;
        text-transform: uppercase;
        font-weight: 400;
    }
    .value {
        font-size: 1.25rem;
        font-weight: 400;
    }

    .selected {
        border-color: get('colors.Secondary');
        background-color: get('colors.Secondary');
        color: white;
    }

    .selected * {
        border-color: get('colors.Secondary');
        background-color: get('colors.Secondary');
        color: white;
    }

    /*.item:hover {*/
    /*    border-color: #009bea;*/
    /*    background-color: #009bea;*/
    /*    cursor: pointer;*/
    /*}*/
    /*.item:hover * {*/
    /*    color: white;*/
    /*    background-color: #009bea;*/
    /*}*/
</style>
